import { Routes } from '@angular/router';
import { ReportListComponent } from './components/report-list/report-list.component';

export const routes: Routes = [
  { path: '', component: ReportListComponent },
  { path: 'report', redirectTo: '', pathMatch: 'full' },
  {
    path: 'report',
    loadChildren: () => import('./reports/report.routes').then(m => m.REPORT_ROUTES)
  },
];
